<template>

  <generic-card
      :byContent="true"
      @click="$emit('click')"
      @delete="$emit('deleteOutgoingInvoice')"
      :allowDelete="('orders' in outgoingInvoice) && outgoingInvoice.orders.length == 0"
  >
    <template #content>
      <content-outgoing-invoice
          :outgoingInvoice="outgoingInvoice"
          :isParentMethodPriority="true"
          :isPayable="isPayable"
          :isDeletable="false"
          @pay="$emit('pay')"
      />
    </template>

  </generic-card>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import GenericCard from './Card'
import ContentOutgoingInvoice from './components/OutgoingInvoiceContent'

export default {
  components: {
    GenericCard,
    ContentOutgoingInvoice
  },
  props: {
    outgoingInvoice: {
      type: Object,
      default: () => {}
    },
    isPayable: {
      type: Boolean,
      default: false
    },
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>